import { Link } from "react-router-dom"
import { useConsent } from "@/context/consent/consent-context"

export function Footer() {
	const { reset } = useConsent()

	return (
		<footer className="py-8 border-t border-sky-900/10 dark:border-sky-100/10 bg-sky-50/50 dark:bg-background/50 transition-colors duration-300 backdrop-blur-sm mt-auto">
			<div className="container mx-auto flex flex-col items-center justify-center gap-2 text-sm font-medium text-sky-900/60 dark:text-sky-100/50">
				<p>© {new Date().getFullYear()} BeeDiv. Smart Investing for Busy Bees.</p>

				<div className="flex gap-4 text-xs opacity-80">
					<Link
						to="/privacy"
						className="hover:text-sky-900 dark:hover:text-sky-100 cursor-pointer transition-colors"
					>
						Privacy Policy
					</Link>
					<span>•</span>
					<Link
						to="/terms"
						className="hover:text-sky-900 dark:hover:text-sky-100 cursor-pointer transition-colors"
					>
						Terms of Service
					</Link>
					<span>•</span>
					<button
						onClick={reset}
						className="hover:text-sky-900 dark:hover:text-sky-100 cursor-pointer transition-colors"
					>
						Cookie Settings
					</button>
				</div>
			</div>
		</footer>
	)
}
